import QueryWhereNode from './query-where-node';
// eslint-disable-next-line import/no-cycle
import QueryWhereRule from './query-where-rule';

/**
 * @param {any} r
 * @param {?(QueryWhereNode | 'parent')} node
 * @param {?QueryWhereRules | import('./query-where-child').default} parent
 * @returns {QueryWhereRule | QueryWhereRules | undefined}
 */
export const rulesMap = (r, node = null, parent = null) => {
	let rule;
	if (r.field) {
		rule = new QueryWhereRule(r);
		if (node instanceof QueryWhereNode) {
			rule.setNode(node);
			if (parent) {
				rule.setParent(parent);
			}
		}
		else {
			console.warn('no node!', node);
		}
	}
	else if (r.items) {
		// eslint-disable-next-line no-use-before-define
		rule = new QueryWhereRules(r);
	}
	return rule;
};

export default class QueryWhereRules {
	/**
	 * @param {any} rules
	 * @param {?QueryWhereNode} node
	 */
	constructor(rules = null, node = null) {
		/** @type {'AND' | 'OR'} */
		this.condition = rules?.condition || 'AND';

		/** @type {(QueryWhereRule | QueryWhereRules)[]} */
		this.items = rules?.items?.map((/** @type {any} */ item) => rulesMap(item, node, this)) || [];
	}
}
